import { Spinner, useEnvironment } from "@keycloak/keycloak-ui-shared";
import { Suspense, useEffect, useState } from "react";
import {
  createBrowserRouter,
  Outlet,
  RouteObject,
  RouterProvider,
} from "react-router-dom";
import { Environment, environment } from "../environment";
import { Header } from "./Header";
import { MenuItem, PageNav } from "./PageNav";
import { routes } from "../routes";
import {PersonalInfo, usePersonalInfoContext} from "../providers/PersonalInfoProvider";
import Page from "./Page";
import Logo from "./Logo";
import { MenuProvider } from "../providers/MenuProvider";
import { ErrorPage } from "./ErrorPage";
import { useContentContext } from "../providers/ContentProvider";

type MapRoute = {
    label: string
} & RouteObject

function mapRoutes(content: MenuItem[]): MapRoute[] {
  return content
    .map((item) => {
      if ("children" in item) {
        return mapRoutes(item.children);
      }
      return {
        ...item,
        element:
          "path" in item
            ? routes.find((r) => r.path === (item.id ?? item.path))?.element
            : undefined,
      };
    })
    .flat() as MapRoute[];
}

export const Root = () => {
  const context = useEnvironment<Environment>();
  const {accountType}: PersonalInfo = usePersonalInfoContext();
  const content = useContentContext();
  const [routers, setRouters] = useState<RouteObject[]>();

  useEffect(() => {
    if (accountType && content) {
        setRouters([
            {
                path: decodeURIComponent(new URL(environment.baseUrl).pathname),
                element: (
                  <MenuProvider>
                    <Page Logo={Logo} Header={Header} Sidebar={PageNav} accountType={accountType} keycloak={context.keycloak}>
                        <Suspense fallback={<Spinner />}>
                            <Outlet />
                        </Suspense>
                    </Page>
                  </MenuProvider>
                ),
                errorElement: <ErrorPage />,
                children: mapRoutes(content),
            },
        ]);
    }
  }, [accountType, content]);

  if (!routers) {
    return <Spinner />;
  }
  return <RouterProvider router={createBrowserRouter(routers)} />;
};
